import { createAsyncThunk } from '@reduxjs/toolkit'
import { ColumnFiltersState } from '@tanstack/react-table'
import { Axios } from 'api/axios'
import { config } from 'config/env'
import axios from 'axios'
const API_URL = config.api.baseUrl
const headers = {
  'Content-Type': 'application/json'
}

export interface Organisation {
  id?: number
  packageName: string
  districtCode: string
  districtName: string
  state: string
  status: boolean
  createBy?: string
  updatedBy?: string
  createDate?: string
  updateDate?: string
}
export interface PaginatedResponse<T> {
  count: number
  total_pages: number
  next: string | null
  previous: string | null
  results: T[]
}

export const fetchUser = createAsyncThunk(
  'user/fetchUsers',
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters
  }: {
    page: number
    pageSize: number
    search?: string
    sort?: string
    order?: 'asc' | 'desc' | ''
    filters?: ColumnFiltersState
  }) => {
    try {
      const params: Record<string, any> = {
        page,
        page_size: pageSize
      }

      if (search) params.search = search?.trim() || ''


      // Build the ordering param for the API
      if (sort) {
        const mappedSort = sort === 'user_type_name' ? 'user_type_name' : sort;
        params.ordering = order === 'desc' ? `-${mappedSort}` : mappedSort;
      }

      //Add each filter as a query param (e.g. organization_name=...)
      if (filters && Array.isArray(filters)) {
        filters.forEach(filter => {
          const { id, value } = filter
          if (!id || value === undefined || value === '') return
          if (
            (id === 'updated_at' || id === 'created_at') &&
            typeof value === 'object'
          ) {
            const { from_date, to_date } = value as {
              from_date?: string
              to_date?: string
            }
            if (id === 'updated_at') {
              if (from_date) params['updated_at_from'] = from_date
              if (to_date) params['updated_at_to'] = to_date
            }
            if (id === 'created_at') {
              if (from_date) params['created_at_from'] = from_date
              if (to_date) params['created_at_to'] = to_date
            }

          } else {
            params[id] = value
          }

        })
      }

      const response: any = await Axios.get(`/users/list/`, { params })

      // console.log("response: ", response)

      const responseData = response.data
      return {
        data: responseData?.data || responseData?.results || [],
        rowCount: responseData?.count || 0
      }
    } catch (error: any) {
      console.error('fetchUser error:', error.response?.data || error.message)
      throw new Error(error.response?.data?.message || 'Failed to fetch Users')
    }
  }
)

// export const createUser = createAsyncThunk(
//   "user/createUser",
//   async (userData: any, { rejectWithValue }) => {
//     try {
//       const response = await Axios.post(`/users/register/`, userData, {
//         headers,
//       });

//       return response.data; // adjust depending on your backend's response format
//     } catch (err: any) {
//       console.error("Create User Error:", err);
//       return rejectWithValue(err.response?.data || "Failed to create user");
//     }
//   }
// )

export const createUser = createAsyncThunk(
  'user/createUser',
  async (userData: any, { rejectWithValue }) => {
    try {
      const response = await Axios.post(`/users/register/`, userData, {
        headers
      })

      return response.data // adjust depending on your backend's response format
    } catch (err: any) {
      console.error('Create User Error:', err)
      return rejectWithValue(err.response?.data || 'Failed to create user')
    }
  }
)

export const fetchOrganisationById = createAsyncThunk(
  'organisation/fetchById',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`${API_URL}/organisation/${id}/`)
      console.log('resp to update Id : ', response)
      return response
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || 'Failed to fetch organisations by ID'
      )
    }
  }
)

export const updateOrganisation = createAsyncThunk(
  'organisation/updateOrganisation',
  async (packageData: any) => {
    // const token = localStorage.getItem("authToken");
    // if (!token) {
    //   throw new Error("No authentication token found");
    // }
    console.log('pkgData:', packageData)
    const response: any = await Axios.put(
      `${API_URL}/organization/${packageData.id}/update/`,
      packageData
    )
    console.log('updateOrganisation response:', response)
    return response
  }
)
export const updateStatusInOrg = createAsyncThunk(
  'organisation/updateOrganisation2',
  async (packageData: any) => {
    console.log('pkgData:', packageData)
    const response: any = await Axios.put(
      `${API_URL}/organization/${packageData.id}/update/`, // <-- add 'api/' here, no extra slash after API_URL
      packageData
    )
    console.log('updateOrganisation response:', response)
    return response
  }
)

export const addOrganisation = createAsyncThunk(
  'organisation/addOrganisation',
  async (packageData: any) => {
    // const token = localStorage.getItem("authToken");
    // if (!token) {
    //   throw new Error("No authentication token found");
    // }

    const response = await Axios.post(`${API_URL}/organisation/`, packageData)
    // console.log('addOrganisation response:', response)
    // console.log('addOrganisation response:', response.data)
    return response.data
  }
)

export const deleteOrganisation = createAsyncThunk(
  'packages/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      await axios.delete(`${API_URL}/${id}`, { headers })
      return id
    } catch (err: any) {
      console.error('Delete error:', err)
      return rejectWithValue(err.response?.data?.message || err.message)
    }
  }
)

export const updateStatusInUsers = createAsyncThunk(
  `updateusers/updateStatusInUsers`,
  async ({ id, is_active }: { id: string, is_active: boolean }) => {
    const response = await Axios.patch(
      `/users/update-status/${id}`,
      { is_active }
    )
    return response
  }
)

export const fetchDropdownByColumn = createAsyncThunk(
  'organization/fetchDropdownByColumn',
  async (columnId: string) => {
    let endpoint = ''

    switch (columnId) {
      case 'first_name':
        endpoint = '/users/dropdown/first_name/'
        break
      case 'last_name':
        endpoint = '/users/dropdown/last_name/'
        break
      case 'username':
        endpoint = '/users/dropdown/username/'
        break
      case 'organization_name':
        endpoint = '/organization/all-org/'
        break
      case 'industry_type':
        endpoint = '/organization/dropdown/industry_type/'
        break
      case 'org_city':
        endpoint = '/organization/dropdown/org_city/'
        break
      case 'org_state':
        endpoint = '/organization/dropdown/org_state/'
        break
      case 'org_pincode':
        endpoint = '/organization/dropdown/org_pincode/'
        break
      default:
        throw new Error(`No dropdown endpoint for ${columnId}`)
    }

    const response = await Axios.get(`${API_URL}${endpoint}`, { headers })

    console.log('API Response for', columnId, '=>', response.data)


    if (['first_name', 'last_name', 'username'].includes(columnId)) {
      return {
        key: `${columnId}DropDown`,
        data: Array.isArray(response.data[columnId])
          ? response.data[columnId]
          : []
      }
    }

    if (columnId === 'organization_name') {
      return {
        key: 'orgDropDown',
        data: Array.isArray(response.data.data)
          ? response.data.data.map((item: any) => item.organization_name)
          : []
      }
    }

    return {
      key: `${columnId}DropDown`,
      data: Array.isArray(response.data[columnId])
        ? response.data[columnId]
        : []
    }
  }
)

//Exports csv file
// Exports department CSV file
export const exportUsersCSV = createAsyncThunk(
  'users/exportUsersCSV',
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('authToken');

      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: '*/*',
      };

      const response = await Axios.get('users/list/?export=excel', {
        headers,
        responseType: 'blob',
      });

      return {
        blob: response.data,
        filename:
          response.headers['content-disposition']
            ?.split('filename=')[1]
            ?.replace(/"/g, '') || 'users.csv',
      };
    } catch (err: any) {
      console.error('Export CSV error:', err);
      return rejectWithValue(err.message || 'Failed to export CSV');
    }
  }
);

export const UsersxportsCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();
  params.append("export", "excel");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(({ id, value }: { id: string; value: any }) => {
      if (id && value !== undefined && value !== null) {
        if (typeof value === "object" && value !== null) {
          const maybeDateFilter = value as {
            from_date?: string;
            to_date?: string;
          };

          if (maybeDateFilter.from_date || maybeDateFilter.to_date) {
            if (maybeDateFilter.from_date) {
              params.append(`${id}_from`, maybeDateFilter.from_date);
            }
            if (maybeDateFilter.to_date) {
              params.append(`${id}_to`, maybeDateFilter.to_date);
            }
            return;
          }

          Object.entries(value).forEach(([key, val]) => {
            if (val !== undefined && val !== null && val !== "") {
              params.append(key, String(val));
            }
          });
        } else {
          params.append(id, String(value));
        }
      }
    });
  }

  const response = await Axios.get(`/users/list/?${params.toString()}`, {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "Users.csv",
  };
};


export const fetchALLUserFormDropdowns = createAsyncThunk(
  'user/fetchAllUserFormDropdowns',
  async () => {
    try {
      const urls = [
        `${API_URL}/user-types/dropdown/`,
        `${API_URL}/organization/all-org/`,
        `${API_URL}/department/get-all/`,
        `${API_URL}/teams/get-all`,
        // `${API_URL}/organization/dropdown/org_state/`
      ]
      const [userTypesRes, orgRes, departmentRes, teamsRes] =
        await Promise.all(urls.map(url => Axios.get(url, { headers })))
      // console.log(userTypesRes,"userTypesRes---------------1")
      return {
        userTypes: Array.isArray(userTypesRes?.data?.data) ? userTypesRes.data.data : [],
        organizations: Array.isArray(orgRes?.data?.data)
          ? orgRes?.data?.data
          : [],
        departments: Array.isArray(departmentRes?.data?.data)
          ? departmentRes?.data?.data
          : [],
        teams: Array.isArray(teamsRes?.data?.data) ? teamsRes?.data?.data : [],
        // states: Array.isArray(stateRes.data?.org_state)
        //   ? stateRes.data.org_state
        //   : []
      };
    } catch (err) {
      console.error('Error fetching user form dropdowns:', err)
      throw err
    }
  }
)




